// Auto-generated by scripts/write-generated-version-file.js - do not edit manually
export const MONOREPO_VERSION = '1.33.1-5f3dd5e' as const;
export type MonorepoVersion = typeof MONOREPO_VERSION;
